( function( $ ) {
	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-value-prop' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			window.app.main.initFontAdjustment( this );
			const $sectionInstance = $( this );

			if ( $sectionInstance.hasClass( 'section-value-prop--style-v2' ) ) {

				if ( window.app.options.isMobile || window.app.options.isTablet ) {
					$sectionInstance.find( '.value-prop__item' ).on( 'click', function() {
						let $link = $( this );

						const $sectionServicesTab = $sectionInstance.find( '.value-prop__list .scrollbar-outer' );
						const $scrollContent = $sectionInstance.find( '.value-prop__list .scroll-content' );

						if ( $scrollContent.length ) {
							const navItemsRect = $scrollContent[0].getBoundingClientRect();
							const navItemActiveRect = $link[0].getBoundingClientRect();
							const navItemsLeft = $scrollContent.scrollLeft() + navItemActiveRect.left - navItemsRect.left + ( navItemActiveRect.width - navItemsRect.width ) / 2;
							$scrollContent.animate( { scrollLeft: navItemsLeft }, 600, 'swing' );
						} else {
							const navItemsRect = $sectionServicesTab[0].getBoundingClientRect();
							const navItemActiveRect = $link[0].getBoundingClientRect();
							const navItemsLeft = $sectionServicesTab.scrollLeft() + navItemActiveRect.left - navItemsRect.left + ( navItemActiveRect.width - navItemsRect.width ) / 2;
							$sectionServicesTab.animate( { scrollLeft: navItemsLeft }, 600, 'swing' );
						}
					} );
				}
			}
		} );
	};

	window.app.loadBlock( initBlock, 'section-value-prop', '.section-value-prop' );
} )( jQuery );
